import Box, { Item } from "devextreme-react/box";
import { useContext } from "react";
import { OrderStatus } from "../../../../types/enums";
import { PurchaseOrderContext } from "../context/PurchaseOrderContext";
import CFIInformationCard from "./CFIInformationCard";
import CustomerInformationCard from "./CustomerInformationCard";
import PendingOrderCard from "./PendingOrderCard";
import PurchaseOrderDatesCard from "./PurchaseOrderDatesCard";
import PurchaseOrderInformationCard from "./PurchaseOrderInformationCard";

export default function PurchaseOrderCards(props: { showDates?: boolean, showCustomerInfo?: boolean }) {

	const { order } = useContext(PurchaseOrderContext);

	return (
		<>
			{
				order.details.orderStatusID === OrderStatus.Pending ?
					<PendingOrderCard />
					:
					<Box className='order-cards'>
						<Item ratio={1}>
							<PurchaseOrderInformationCard />
						</Item>
						{
							props.showCustomerInfo &&
							<Item ratio={1}>
								<CustomerInformationCard />
							</Item>
						}
						<Item ratio={1}>
							<CFIInformationCard />
						</Item>
						{
							props.showDates &&
							<Item ratio={1}>
								<PurchaseOrderDatesCard />
							</Item>
						}
					</Box>
			}
		</>
	)
}
